import handleNateApiResponse from '@/helpers/handle_nate_api_response';
import nateFetch from '@/helpers/nate_fetch';
import useNotificationsStore from '@/stores/notifications';
import useStationsStore from '@/stores/stations';

export default async function performNateApiRequest({ station, endpoint }) {
  if (!station?.nateApiUrl) {
    return;
  }

  const stationsStore = useStationsStore();
  const { refreshOne } = stationsStore;

  const response = await nateFetch(`${station.nateApiUrl}${endpoint}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
  });

  let data = null;

  try {
    data = await response.json();
  } catch {
    // Response body may be empty or non-JSON (e.g. proxy short-circuit); leave data as null.
  }

  if (!response.ok) {
    // Error bodies here are proxy-generated (offline short-circuit, dead upstream), not
    // NATE responses — don't feed them to the messages/success handler.
    const { addNotification } = useNotificationsStore();
    const message = data?.error === 'station_offline' ? 'Station is offline.' : 'Request failed.';
    addNotification({ type: 'error', title: `Station #${station.number}`, message });
  } else if (data) {
    handleNateApiResponse(data);
  }

  await refreshOne({ host: station.host });
}
